import { render, staticRenderFns } from "./AirQualityInUrban.vue?vue&type=template&id=39a16f76&"
import script from "./AirQualityInUrban.vue?vue&type=script&lang=js&"
export * from "./AirQualityInUrban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports